import React, { useState } from 'react';
import { ClipStage } from '../ClipStage';
import { DefectHighlight } from '../DefectHighlight';
import { useBeats } from '../../hooks/useBeats';
import { defects, problemClip } from '../../data/teaser';

// summary line, then the three defect labels
const BEATS = [700, 1200, 1800, 2400];
export function ScreenProblem() {
  const beat = useBeats(BEATS);
  const [selected, setSelected] = useState<number | null>(null);
  const revealed = Math.min(Math.max(beat - 1, 0), defects.length);
  const highlighted = selected ?? (revealed > 0 ? revealed - 1 : null);
  const detail = selected === null ? null : defects[selected];
  return <section className="flex h-full w-full flex-col justify-start pt-1" data-id="element-55" data-mp="156osr82q5nx6">
      <h1 className="text-[26px] font-extrabold leading-tight text-white animate-fade-in-up" data-id="element-56" data-mp="196ffn0p4rjwf">
        Conventional attachments add more than time.
      </h1>

      <div className="relative mt-4 animate-pop-in" data-id="element-57" data-mp="1j5o7no0fqog5">
        <ClipStage clip={problemClip} heightClass="h-28" data-id="element-58" data-mp="1j66a52doxywi" />
        <DefectHighlight cue={highlighted} data-id="element-59" data-mp="3pctjsizienw0" />
      </div>

      <p className={`mt-4 font-headline text-lg font-extrabold leading-snug text-white transition-all duration-300 ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-60" data-mp="3pdle7qhdefkp">
        Small attachment defects can mean more chair time, less predictable
        forces and greater risk of rework.
      </p>

      <div className="mt-4 grid grid-cols-3 gap-2" data-id="element-61" data-mp="bxnj5r5oyjg2">
        {defects.map((defect, index) => {
        const isSelected = selected === index;
        const isDimmed = selected !== null && !isSelected;
        return <button key={defect.name} onClick={() => setSelected(isSelected ? null : index)} aria-pressed={isSelected} aria-label={`Explain ${defect.name}`} className={`rounded-xl border px-2 py-3 font-headline text-base font-extrabold transition-all duration-300 ${beat >= index + 2 ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'} ${isSelected ? 'border-solventum-primary bg-solventum-primary text-solventum-bg' : isDimmed ? 'border-white/10 bg-white/[0.02] text-white/45' : 'border-white/15 bg-white/[0.04] text-white'}`} data-id="element-62" data-mp="33ivthprnq5a" data-mpi={index}>
              {defect.name}
            </button>;
      })}
      </div>

      {/* fixed slot so opening an explanation never pushes into the CTA */}
      <div className="mt-3 h-[104px]" data-id="element-63" data-mp="i00j9jpgy9ss">
        {detail ? <div key={detail.name} className="flex h-full gap-3 overflow-hidden rounded-2xl border border-solventum-primary/40 bg-solventum-primary/[0.06] p-2.5 animate-rise-in" data-id="element-64" data-mp="i1trh3fqd22w">
            <img src={detail.image} alt="" aria-hidden="true" className="h-full w-[76px] flex-shrink-0 rounded-xl object-cover" data-id="element-65" data-mp="2cbxgjtale9vr" />
            <p className="font-body text-[12.5px] leading-snug text-white/85" data-id="element-66" data-mp="4pnjv5c0iju7">
              {detail.body}
            </p>
          </div> : <p className={`px-1 font-body text-[13px] text-white/40 transition-opacity duration-300 ${beat >= 4 ? 'opacity-100' : 'opacity-0'}`} data-id="element-67" data-mp="eiuwnb93124b">
            Tap any of the three to see why.
          </p>}
      </div>
    </section>;
}